import React from "react";
import styles from "./NavBtn.module.css";

function NavBtn({
  size,
  style,
  btnStyle,
  flex,
  logo,
  inicio,
  gallery,
  aboutMe,
  contact,
  faq,
  galleryAmigurumis,
  galleryAnime,
  galleryChenille,
  galleryKeychain,
  galleryRandom,
}) {
  return (
    <div style={style} className={styles.container}>
      <button className={styles.logoBtn} onClick={inicio}>
        <img src={logo} alt="logo" className={styles.logo} style={size}></img>
      </button>
      <div className={styles.btns} style={flex}>
        <button className={styles.nav} onClick={inicio}>
          Inicio
        </button>
        <div className={styles.containerBtn}>
          <button className={styles.galleryBtn} onClick={gallery}>
            Galería
          </button>
          <div className={styles.galleryBtns} style={btnStyle}>
            <button className={styles.nav} onClick={galleryAmigurumis}>
              Amigurumis
            </button>
            <button className={styles.nav} onClick={galleryChenille}>
              Suavecitos
            </button>
            <button className={styles.nav} onClick={galleryAnime}>
              Anime y Juegos
            </button>
            <button className={styles.nav} onClick={galleryKeychain}>
              Llaveros y colgantes
            </button>
            <button className={styles.nav} onClick={galleryRandom}>
              Detalles únicos
            </button>
          </div>
        </div>

        <button className={styles.nav} onClick={aboutMe}>
          Sobre Mí
        </button>
        <button className={styles.nav} onClick={contact}>
          Contacto
        </button>
        <button className={styles.nav} onClick={faq}>
          Preguntas frecuentes
        </button>
      </div>
    </div>
  );
}

export { NavBtn };
